import classify from "../../pages/templates/helpers/classify";
import plangridTrackEvents from "./amplitudeInit-vanilla";

const addSecurityScrollHandlers = () => {
  const navLinks = document.querySelectorAll(".navigation a");
  const navigation = document.querySelector(".security-page .navigation");

  navLinks.forEach(link => {
    link.addEventListener("click", e => {
      e.preventDefault();
      navigation.classList.remove("open");
      let section;

      const className = classify(link.innerHTML.trim());

      if (className == "international-service") {
        section = document.querySelector("#available-worldwide");
      } else {
        section = document.querySelector(`#${className}`);
      }

      section.scrollIntoView();

      window.scrollBy(0, -95);
    });
  });
};

const addScrollHandler = () => {
  const container = document.querySelector(".navigation ul");
  const footer = document.querySelector("#footer-navigation");
  const page = document.querySelector(".content");

  const margin = 120;

  window.addEventListener("scroll", () => {
    const containerHeight = Math.min(container.offsetHeight, page.offsetHeight);
    const footerHeight = footer.offsetHeight;
    const footerTop = document.body.offsetHeight - footerHeight;

    if (window.matchMedia("(min-width: 62em)").matches) {
      if (containerHeight + pageYOffset + margin > footerTop) {
        container.style.position = "fixed";
        container.style.top = "100px";
        container.style.maxHeight = `${(pageYOffset + margin - footerTop) *
          -1}px`;
      } else if (pageYOffset > 280) {
        container.style.position = "fixed";
        container.style.top = "100px";
        container.style.maxHeight = "500px";
      } else {
        container.style.position = "absolute";
        container.style.top = "0";
        container.style.maxHeight = `${Math.min(500, page.offsetHeight)}px`;
        document.body.overflowY = "auto";
      }
    }
  });
};

const addNavigationHandler = () => {
  const navigation = document.querySelector(".security-page .navigation");
  const button = navigation.querySelector("button");

  button.addEventListener(
    "click",
    e => {
      navigation.classList.toggle("open");
    },
    false
  );

  document.body.addEventListener(
    "click",
    e => {
      if (!navigation.contains(e.target)) {
        navigation.classList.remove("open");
      }
    },
    false
  );
};

const submitWebinarForm = () => {
  const joinForm = MktoForms2.getForm(1241);
  const form = document.forms["soc2-report-request"];
  const wrapper = document.querySelector(".report-request");

  joinForm.onSuccess(function(values, followUpUrl) {
    wrapper.classList.add("confirmation");
    return false;
  });

  joinForm.setValues({
    Email: form.email.value,
  });

  joinForm.submit();
};

const addMarketoHandlers = () => {
  const form = document.forms["soc2-report-request"];

  form.addEventListener("submit", e => {
    e.preventDefault();
    const email = form.email.value;
    const emailValid = /@.*?\./.test(email);

    if (emailValid) {
      submitWebinarForm();
    } else {
      form.classList.add("email-error");
    }
  });
};

const init = () => {
  addSecurityScrollHandlers();
  addScrollHandler();
  plangridTrackEvents("/security");
  addNavigationHandler();
  addMarketoHandlers();
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1241);
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/security.js